import React, { useEffect, useState } from "react";

import { initEnvironmentVariables } from "./components/utils/envConfiguration";

const Bootstrap = () => {
    const [App, setApp] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        (async () => {
            await initEnvironmentVariables();

            const [
                appModule,
                keycloakModule,
                cacheModule,
                constantsModule,
            ] = await Promise.all([
                import("./App"),
                import("./components/utils/Keycloak"),
                import("./components/utils/Cache"),
                import("./components/utils/Constants"),
            ]);

            const keycloak = keycloakModule.default;
            const Cache = cacheModule.default;
            const constants = constantsModule.default || constantsModule;
            const {
                getAllBonusCategories,
                getAllBonusCities,
                getAllBonusCitiesForCreate,
                getAllCities,
                getAllHelpStatus,
                getAllOffices,
            } = constants;

            setTimeout(() => {
                if (keycloak.authenticated) {
                    Cache.set("allOffices", getAllOffices(keycloak.token));
                    Cache.set("allCities", getAllCities(keycloak.token));
                    Cache.set("allHelpStatus", getAllHelpStatus(keycloak.token));
                    Cache.set("allBonusCategories", getAllBonusCategories(keycloak.token));
                    Cache.set("allBonusCities", getAllBonusCities(keycloak.token));
                    Cache.set("getAllBonusCitiesForCreate", getAllBonusCitiesForCreate(keycloak.token));
                    setApp(() => appModule.default);
                }
            }, 1000);
        })().catch(setError);
    }, []);

    if (error) {
        throw error;
    }

    return App ? <App /> : null;
};

export default Bootstrap;
